import React, { useState, useEffect, useCallback } from 'react';
import styles from './card-carousel.module.css';

function CardCarousel({ cards }) {
    const [positions, setPositions] = useState([0, 1, 2]); // 0=left, 1=center, 2=right

    const getCardPosition = (index) => {
        const position = positions.indexOf(index);
        if (position === 0) return styles.left;
        if (position === 1) return styles.center;
        return styles.right;
    };

    const rotateCards = useCallback(() => {
        setPositions(prev => [(prev[1]), (prev[2]), (prev[0])]);
    }, []);

    useEffect(() => {
        const interval = setInterval(rotateCards, 3000); // Rotate every 3 seconds
        return () => clearInterval(interval);
    }, [rotateCards]);

    return (
        <div className={styles.carouselContainer}>
            {cards.map((card, index) => (
                <div
                    key={card.id}
                    className={`${styles.card} ${getCardPosition(index)}`}
                >
                    <div className={styles.cardContent}>
                        {card.content}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default CardCarousel;